const AddressType = {
  SHIPPING: 1,
  BILLING: 2,
};

export default AddressType;
